export default {

  required: {
    message : "Please enter your message.",
    fn      : (input)=> input.length,
  },

}
